import type { StorageAdapter } from '@/services/storage/storage-adapter';
import { recordPendingDelete } from './sync-service';

/**
 * Hunt service layer (ADR-019 soft-delete propagation).
 *
 * Mirrors PropertyService: the store calls the service, the service owns the
 * pending-delete enqueue (RULE-081 — services never import stores; the
 * store → service → adapter+enqueue direction stays clean).
 *
 * Scope: deleteHunt only. The store still performs its other hunt operations
 * (load/create/update) directly against the adapter; this service exists solely
 * to route hunt deletes through recordPendingDelete so the remote row's
 * deleted_at gets set on the next sync push (preventing cross-device
 * resurrection).
 *
 * Child-cascade decision (OPTION (a) — single 'hunt' enqueue, no child
 * enqueues): harvestRecord has NO deleted_at column and softDeleteHarvestRecord
 * is a HARD delete, so enqueuing 'harvestRecord' here would hard-delete remote
 * harvest data (data-loss-adjacent). Blanket child-enqueue is therefore
 * rejected. Orphaned-children handling is tracked as a separate follow-up.
 */
export class HuntService {
  constructor(private adapter: StorageAdapter) {}

  async deleteHunt(id: string): Promise<void> {
    await this.adapter.deleteHunt(id);
    await recordPendingDelete(id, 'hunt');
  }
}
